require([
    'jquery',
    'base/MbiHelper',
    'flickity',
    'base/MbiImageSize'
], function(
    $,
    _,
    Flickity,
    mbiImageSize
    ) {
    'use strict'

$.flickityObjects = [];
function initSwiper() {
    if(_.exists('.swiper')) {
        $('.swiper').each(function() {
            if($(this).find('.slide').length >= 1) {
                var prvbt = false;
                var autoplay = false;
                var buttons = false;
                var wrap = false;
                var adap = true;
                if($(this).parents().hasClass('section-images')) {
                    var adap = false;
                    var wrap = true;
                    var prvbt = true;
                    var autoplay = 4000;
                    var buttons = true;
                }
                var flkty = new Flickity( '#'+$(this).attr('id'), {
                    cellSelector: '.slide',
                    pageDots: prvbt,
                    wrapAround: wrap,
                    autoPlay: autoplay,
                    draggable: true,
                    prevNextButtons: buttons,
                    adaptiveHeight: adap
                });

                var test = $(document).find('.button-row').clone(true);
                $(document).find('.button-row').remove();
                $('.wohnungen-uebersicht').append(test);
                var $cellButtonGroup = $(document).find('[data-buttons="'+$(this).attr('id')+'"]');
                var $cellButtons = $cellButtonGroup.find('.button');

                // update selected cellButtons
                // flkty.on( 'select', function() {
                //   $cellButtons.filter('.is-selected')
                //     .removeClass('is-selected');
                //   $cellButtons.eq( flkty.selectedIndex )
                //     .addClass('is-selected');
                // });
                flkty.on('cellSelect', function() {
                    if($(this.element).hasClass('is_active')) {
                        var $cellButtonGroup = $(document).find('[data-buttons="'+$(this.element).attr('id')+'"]');
                        // console.log($cellButtonGroup.find('.button[data-key="'+flkty.selectedIndex+'"]').find('.planurl'));
                        // console.log($cellButtons.eq(flkty.selectedIndex));
                        // console.log(flktdata.selectedIndex);
                        $('.button').removeClass('is_active');
                        $cellButtonGroup.find('.button[data-key="'+flkty.selectedIndex+'"]').addClass('is_active');
                        var plan = $cellButtonGroup.find('.button[data-key="'+flkty.selectedIndex+'"]').find('.planurl');
                        if (plan.parent().hasClass('verkauft')) {
                            $cellButtonGroup.find('.geschossplan').attr('src', plan.html()).addClass('verkauft');
                        } else {
                            $cellButtonGroup.find('.geschossplan').attr('src', plan.html()).removeClass('verkauft')
                        }
                    }

                });
                // select cell on button click
                $cellButtonGroup.on( 'click', '.button', function() {

                    if($(this).hasClass('js_next-slide')) {
                        flkty.next(true);
                        // $(flkty.element).find
                        // flkty.css('height', flkty.selectedElement);
                        $('.button').removeClass('is_active');
                        var bu = $cellButtonGroup.find('.button[data-key="'+flkty.selectedIndex+'"]').find('.planurl');
                        $(flkty.element).find('.button[data-key="'+flkty.selectedIndex+'"]').addClass('is_active');
                        // console.log(bu);
                        if(bu.parent().hasClass('verkauft')) {
                            $(this).parent().find('.geschossplan').attr('src', bu.html()).addClass('verkauft');
                        } else {
                            $(this).parent().find('.geschossplan').attr('src', bu.html()).removeClass('verkauft');
                        }
                    } else {
                        $('.button').removeClass('is_active');
                        $(this).addClass('is_active');
                            var index = $(this).attr('data-key');
                            flkty.select(index);
                            var bu = $cellButtonGroup.find('.button[data-key="'+flkty.selectedIndex+'"]').find('.planurl');
                            // console.log(bu);
                            if(bu.parent().hasClass('verkauft')) {
                                $(this).parent().find('.geschossplan').attr('src', bu.html()).addClass('verkauft');
                            } else {
                                $(this).parent().find('.geschossplan').attr('src', bu.html()).removeClass('verkauft');
                            }
                        }
                });
                // previous

                $.flickityObjects['#'+$(this).attr('id')] = flkty;
        }
            $(this).addClass('is-visible');

        });

        setTimeout(function(){

            mbiImageSize.init();
        },100);
    }
}
    $(document).on('AjaxSwapDone', function(){
        $('.slide img').attr('width', $(window).width());
        initSwiper();
    });
    initSwiper();
});

define("root/Assets/Templates/Container/Swiper/Js/Swiper", function(){});

